import React from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { SiteProvider } from './context/SiteContext';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './pages/home/home';
import Support from './pages/supports/support';
import AllEvents from './pages/all-events/all-events';
import EventDetails from './pages/all-events/event-details';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/support" element={<Support />} />
            <Route path="/events" element={<AllEvents />} />
            <Route path="/event-details/:id" element={<EventDetails />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </SiteProvider>
  );
}

export default App;